export default {"src":"/_next/static/media/bg-dot.5cd7681c.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};